const userReviewSlider = () => {
  $('.js-user-review').slick({
    draggable: true,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    touchThreshold: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });
};

export default userReviewSlider;
